const initialValue = {
  data: [],
  error: "",
};

const changePasswordReducer = (state = initialValue, action) => {
  switch (action.type) {
    case "CHANGE_PASSWORD_SUCCESS":
      return {
        ...state,
        data: action.payload,
        error: "",
      };
    case "CHANGE_PASSWORD_FAILURE":
      return {
        ...state,
        data: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default changePasswordReducer;
